import { jsx } from "react/jsx-runtime";
import { SignatureFieldWUT } from "../../../ui/signature-field/signature-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
function SignatureWUT(props) {
  const { fieldType = FIELD_TYPES.SIGNATURE } = props;
  return /* @__PURE__ */ jsx(SignatureFieldWUT, { ...props, fieldType });
}
export {
  SignatureWUT
};
//# sourceMappingURL=signature-wut.js.map
